import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/plugins/store';
import AdminLayout from '@/layouts/AdminLayout'
import DefaultLayout from '@/layouts/DefaultLayout'
import SimpleLayout from '@/layouts/SimpleLayout'
import { Toast } from '@/plugins/toast'

const ConfigPage = () => import('@/views/Config/ConfigPage')
const DocumentPage = () => import('@/views/Document/DocumentPage')
const SignaturePage = () => import('@/views/Signature/SignaturePage')
const SignPage = () => import('@/views/Sign/SignPage')
const Signature = () => import('@/views/Successful/Signature')
const ReadySignature = () => import('@/views/Successful/ready_signature')
const Sign = () => import('@/views/Successful/Sign')

const UserPage = () => import('@/views/User/UserPage')
const UserEdit = () => import('@/views/User/UserEdit')
const UserCreate = () => import('@/views/User/UserCreate')

const PromotionPage = () => import('@/views/Promotion/PromotionPage')
const PromotionEdit = () => import('@/views/Promotion/PromotionEdit')
const PromotionCreate = () => import('@/views/Promotion/PromotionCreate')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: 'signatures',
        name: 'Firmas',
        component: {
        render() {
            return h(resolveComponent('router-view'))
          },
        },
        children: [
          {
            path: '',
            name: 'Firmas ',
            meta: { label: 'Firmas' },
            component: SignaturePage
          },  
        ],
      },
      {
        path: 'document',
        name: 'Documentos',
        component: {
        render() {
            return h(resolveComponent('router-view'))
          },
        },
        children: [
          {
            path: '',
            name: 'Documentos ',
            meta: { label: 'Documentos' },
            component: DocumentPage
          },  
        ],
      },      
      {
        path: 'config',
        name: 'Configuración',
        meta: { label: 'Configuración' },
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        children: [
          {
            path: '',
            name: 'Configuración ',
            meta: { label: 'Configuración' },
            component: ConfigPage
          },
        ]
      },
      
    ],
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminLayout,
    redirect: '/users',
    children: [
      {
        path: 'users',
        name: 'users',
        meta: { label: 'usuarios', middleware: "admin" },
        component: UserPage
      },
      {
        path: 'users/edit/:id',
        name: 'userEdit',
        meta: { label: 'Editar usuario', middleware: "admin" },
        component: UserEdit,
      },
      {
        path: 'users/create',
        name: 'Crear usuario',
        meta: { label: 'Create usuario', middleware: "admin" },
        component: UserCreate,
      },
    ]
  },
  {
    path: '/admin/promotion',
    name: 'Promoción',
    component: AdminLayout,
    //redirect: '/users',
    children: [
      {
        path: '',
        name: 'Promoción ',
        meta: { label: 'Promociones', middleware: "admin" },
        component: PromotionPage
      },
      {
        path: '/edit/:id',
        name: 'Editar Promoción',
        meta: { label: 'Editar Promoción', middleware: "admin" },
        component: PromotionEdit,
      },
      {
        path: '/create',
        name: 'Crear Promoción',
        meta: { label: 'Crear Promoción', middleware: "admin" },
        component: PromotionCreate,
      },
    ]
  },
  {
    path: '/sign/:uuid/:description',
    name: 'Sign',
    component: SimpleLayout,
    children: [
      {
        path: '',
        name: 'Firmar Documento ',
        meta: { label: 'Firmar Documento' },
        component: SignPage
      },
    ] 
  },
  {
    path: '/successful_sign',
    name: 'Firma Exitoso',
    meta: { label: 'Firma Exitoso' },
    component: Sign
  },

  {
    path: '/ready_signature/:uuid',
    name: 'Firma Exitosos',
    meta: { label: 'Firma Exitosos' },
    component: ReadySignature
  },
  
  {
    path: '/successful_signature',
    name: 'Envio Exitoso',
    meta: { label: 'Envio Exitoso' },
    component: Signature
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'login/admin',
        name: 'Loginadmin',
        component: () => import('@/views/pages/Loginadmin'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore();
  const user = userStore.getUser
  console.log(user)
  if (to?.meta?.middleware === "admin") {
    if (!user?.is_admin) {
      Toast.fire({
        icon: 'error',
        title: 'No tiene autorización',
      })
      router.push('/dashboard')
      return // Añade esta línea para prevenir llamadas múltiples a next()
    }
    next()
  }
  next()
})

export default router
